import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

@Component({})
export default class GoToTopComponent extends Vue {
  @Prop() readonly isShowButtonGoToTop: boolean;
  @Emit('click') scrollToTop() {}
}
